import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
// import * as Sentry from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Sentry.init({
//   dsn: "https://ffe83ff3fcd96114307a2477d0731d07@o4510176811810816.ingest.de.sentry.io/4510182092439632",
//   sendDefaultPii: true,
//   enabled: false
// });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

